module.exports = __webpack_public_path__ + "assets/3b6bb53a5eb457ac43957ff9aa211911.svg";